import { Box, Container, Typography } from "@mui/material";
import NavBar from "../component/nav-bar";
import IntroBanner from "../component/banner";
import About from "../component/About";
import BookConsultation from "../component/book-consultation";
import Features from "../component/features";
import Testimonials from "../component/Testimonial";
import FooterPage from "../component/FooterPage";
import GetInTouch from "../component/contact";

function Home() {
    return (
        <Box sx={{ paddingTop: 2 }}>
            <NavBar/>

            <IntroBanner/>

            <About/>

            <Features/>

            <Testimonials/>

            <GetInTouch/>

            <FooterPage/>

        </Box>
    );
};
export default Home;